import Vue from "vue"
import App from "./App.vue"

Vue.config.productionTip = false

// Components
import VueCountdown from "@chenfengyuan/vue-countdown"
import VueMq from "vue-mq"

/* Setup Components */
Vue.component(VueCountdown.name, VueCountdown)
Vue.use(VueMq, {
	breakpoints: {
		sm: 767,
		lg: Infinity
	}
})

new Vue({
	render: h => h(App)
}).$mount("#app")
